<template>
  <div>
    <groups-table :view="view" :row-click-enabled="false"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import groupsTable from './table'

export default {
  components: {
    groupsTable
  },
  computed: {
    ...mapState('groups', {
      view: '_archivedView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/groups/archived.vue